import { styled } from "goober";
import type { DisplayableSpace } from "../hooks/useSpaceDisplayName";
import { OverflowBadges } from "./Settings/OverflowBadges";
import { SpaceBadge } from "./SpaceBadge";
import { Text } from "./Text";
import { Tooltip } from "./Tooltip";

const Pill = styled("span")`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  background: var(--alpha4);
  border-radius: 38px;
  color: var(--text-secondary);
  white-space: nowrap;
  flex-shrink: 0;
`;

export function AvailableToCell({
  spaces,
  sharedSpaceCount,
  displaySpaceName,
}: {
  spaces: readonly DisplayableSpace[];
  sharedSpaceCount: number;
  displaySpaceName: (space: DisplayableSpace) => string;
}) {
  if (spaces.length === 0) return <Text variant="text-small">—</Text>;

  if (sharedSpaceCount > 1 && spaces.length === sharedSpaceCount) {
    return (
      <Tooltip
        content={spaces.map((space) => displaySpaceName(space)).join(", ")}
      >
        <Pill>
          <Text variant="text-small-md">All spaces</Text>
        </Pill>
      </Tooltip>
    );
  }

  return (
    <OverflowBadges
      items={spaces}
      keyFn={(space) => space.id}
      renderBadge={(space) => <SpaceBadge space={space} />}
      overflowTooltip={(hidden) =>
        hidden.map((space) => displaySpaceName(space)).join(", ")
      }
    />
  );
}
